import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchAdSenseStatus, insertAdSenseScript, initializeAdSense } from '../../utils/adSenseHelper'

export default function AdUnit() {
  const location = useLocation()
  const adRef = useRef(null)
  const hasInitialized = useRef(false)
  const [adStatus, setAdStatus] = useState({
    enabled: false,
    pageEligible: false,
    adConfig: null
  })

  useEffect(() => {
    let cancelled = false

    const loadStatus = async () => {
      if (process.env.NODE_ENV !== 'production') {
        return
      }

      const host = typeof window !== 'undefined' ? window.location.hostname : ''
      const status = await fetchAdSenseStatus(location.pathname, host)
      if (!cancelled) {
        setAdStatus(status)
      }
    }

    loadStatus()

    return () => {
      cancelled = true
    }
  }, [location.pathname])

  useEffect(() => {
    if (!adStatus.pageEligible || !adStatus.adConfig) {
      return
    }

    if (adStatus.adConfig.adScript) {
      insertAdSenseScript(adStatus.adConfig.adScript)
    }

    if (typeof window !== 'undefined' && window.adsbygoogle && !hasInitialized.current) {
      initializeAdSense()
      hasInitialized.current = true
    }
  }, [adStatus])

  if (process.env.NODE_ENV !== 'production') {
    return null
  }

  if (!adStatus.pageEligible || !adStatus.adConfig) {
    return null
  }

  const clientId = adStatus.adConfig.adClientId || adStatus.adConfig.publisherId || ''
  const slotId = adStatus.adConfig.adSlots?.[0]?.slotId || ''

  if (!clientId) {
    return null
  }

  return (
    <div ref={adRef} className="my-8 flex justify-center" style={{ minHeight: '100px' }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  )
}
